import { render, staticRenderFns } from "./BOMsDelivered.vue?vue&type=template&id=1626c67b&"
import script from "./BOMsDelivered.vue?vue&type=script&lang=js&"
export * from "./BOMsDelivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports